import React from 'react'
import { useDarkMode } from '../../../../rdxsga/hooks/common/useDarkMode';
import { Controller } from 'react-hook-form';
import Label from './Label';
import ErrorMessage from './ErrorMessage';

const ControllerWithTextAreaField = ({labelTextColor=null, control, name, label, placeholder, wrapperClass = "", required = false, rows = 3, cols = 3, disabled = false }) => {
    const darkMode = useDarkMode();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            render={({ field, fieldState }) => (
                <div className={`w-full ${wrapperClass}`}>
                    <Label labelTextColor={labelTextColor} darkMode={darkMode} label={label} required={required} name={name} />
                    <textarea
                        disabled={disabled}
                        {...field}
                        rows={rows}
                        cols={cols}
                        placeholder={placeholder}
                        
                        className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-black"} shadow appearance-none border rounded w-full py-2 px-3  leading-tight border-theme focus:outline-none focus:shadow-outline`}
                    />
                    <ErrorMessage fieldState={fieldState} />
                </div>
            )}
        />
    )
}

export default ControllerWithTextAreaField